import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
/* reducer */
import * as fromMemberDataStore from './state/member-data-store.reducer';

/* effects */
import { MemberDataStoreEffects } from './state/member-data-store.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,

    /* MemberDataStore State */
    StoreModule.forFeature(
      fromMemberDataStore.featureKey,
      fromMemberDataStore.reducer,
      { initialState: fromMemberDataStore.initialState },
    ),
    EffectsModule.forFeature([MemberDataStoreEffects]),
  ],
  exports: [StoreModule, EffectsModule],
})
export class MemberDataStoreModule {}
